<template>
    <div class="product__related product__items products-grid products-products">

        <div v-if="items.length">
            <div class="centered__item about__intro text-center">
                <h4>{{ $t('products.related') }}</h4>
            </div>

        </div>

        <div class="c productscontainer">
            <!-- products -->
            <ul class="products" v-if="items.length">
                <span>
                    <Product v-for="product in products" :key="'product_' + product.id" :data="product"
                        :cart-map="cartMap[`item_${product.id}`]" mode="products" view="grid"
                        :showCartForGuests="showCartForGuests" />
                </span>
            </ul>

        </div>

    </div>
</template>

<script>
import Product from '@/views/products/Product.vue';

export default {
    name: 'Related',
    components: { Product },
    props: {
        cartMap: Object,
        view: String,
        items: Array,
        showCartForGuests: Boolean,
    },
    computed: {
        products() {
            const results = [];
            const items_amount = this.items.length;
            for (let i = 0; i < 8; i += 1) {
                const randomItem = this.items[Math.floor(Math.random() * items_amount)];
                if (!results.find((it) => it.id === randomItem.id)) {
                    results.push(randomItem);
                }
            }
            return results;
        },
    },
};
</script>
